import { POSITIONS, GENDER } from "../constant/constants";
export const adjustDefaultVariants = (variants, isSetMenu) => {
  if (isSetMenu || variants.length > 0) {
    return variants;
  }

  return [
    {
      id: `${Date.now()}`,
      name: "System Default",
      weight: "1",
      isOptionRemoved: "No",
    },
  ];
};

export const staffPostions = Object.values(POSITIONS).map((item) => ({
  label: item,
  value: item,
}));

export const staffGender = Object.values(GENDER).map((item) => ({
  label: item,
  value: item,
}));

export const staffStatusList = [
  {
    label: "Active",
    value: "On",
  },
  {
    label: "Inactive",
    value: "Off",
  },
  {
    label: "All",
    value: "All",
  },
];

export const validateEmergencyContact = (contact = "") => {
  if (!contact) {
    return "";
  }

  if (contact.length !== 11) {
    return "Emergency contact number is less than 11 digit";
  }

  if (!contact.startsWith("0")) {
    return "Emergency contact number is not valid";
  }

  const lastTenDigits = contact.trim().slice(-10);
  const regex = /^(?:\+88|88)?(01[3-9]\d{8})$/;

  if (!regex.test("880" + lastTenDigits)) {
    return "Emergency contact number is not valid";
  }

  return "";
};
